// index.js
import Feature from './Feature';

export default Feature;



// WEBPACK FOOTER //
// ./src/comps/Feature/index.js